import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import _get from 'lodash/get';
import styles from '../Select.module.scss';

export default function ButtonValueContainer(
  props: ValueContainerProps,
): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { selectProps } = valueContainerProps;
  const buttonText = _get(selectProps, ['buttonControlProps', 'buttonText']);

  if (Array.isArray(children)) {
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span>
          {buttonText}
          <span>{children[1]}</span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}
